import type React from 'react';

import emptyProfile from '@shared/assets/images/empty-profile.png';

import * as st from './Image.module.scss';

interface Props {
	url?: string;
}

const Image: React.FC<Props> = ({ url }) => {
	return <img alt="" src={url ?? emptyProfile} className={st.image} />;
};

export default Image;
